import React from 'react';
import PropTypes from 'prop-types';

import arrow from '../../assets/images/arrow-button.svg';
import './MobileListItem.scss';

export default class MobileListItem extends React.Component {

  constructor(props) {
    MobileListItem.propTypes = {
      /** special prop used to transclude content/html within this compnent */
      children: PropTypes.object,
      /** click handler for whole component */
      handleClick: PropTypes.func,
    };
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.stopPropagation();
    this.props.handleClick(e);
  }

  render() {
    return (
      <div className="mobile-list-item" onClick={this.handleClick}>
        {this.props.children}
        <div className="mobile-list-item__right-side">
          {!this.props.hideArrow &&
            <img className="arrow" src={arrow} alt="right arrow" />
          }
        </div>
      </div>
    );
    
  }
}



// WEBPACK FOOTER //
// ./src/components/MobileListItem/index.js